import { DeleteOutlined, EditOutlined, FormOutlined, FileDoneOutlined, TagsOutlined, ShopOutlined, AppstoreOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DeleteSvg from "../../Assets/Svg/delete";
import { delete_table } from "../../Controllers/Global";
import { get_user_auth } from "../../Controllers/Layouts/Layouts";
import AssignCategoryModal from "../../Pages/Products/Categories/Table/AssignCategoryModal.js";
import AssignBrandModal from "../../Pages/Products/Brands/Table/AssignBrandModal.js";
import AssignUnitModal from "../../Pages/Products/Units/Table/AssignUnitModal.js";
import toast from "react-hot-toast";
import { checkUpdatePermission, checkDeletePermission, checkCreatePermission } from "../../Utils/permissionUtils";
import FeatureLockWrapper from "../FeatureLocksWrapper/index.js";
import FeatureUnlockRequestModal from "../FeatureRequestMailForm/index.js";

const ActionButton = (props) => {
  let navigate = useNavigate();

  const edit = props?.edit ? props?.edit : "";
  const id = props?.id ? props?.id : "";
  const cat_Id = props?.cat_Id ? props?.cat_Id : "";
  const brand_Id = props?.brand_Id ? props?.brand_Id : "";
  const unit_Id = props?.brand_Id ? props?.unit_Id : "";
  const api = props?.api ? props?.api : "";
  const actiondata = props?.actiondata;
  const convert = props?.convert ? props?.convert : "";
  const headers = props?.headers;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const productName = props?.productName || "";
  const productData = props?.productData || {};
  const unitData = props?.unitData || {};
  const type = props?.type || "";
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
  const [isBrandModalOpen, setIsBrandModalOpen] = useState(false);
  const [isUnitModalOpen, setIsUnitModalOpen] = useState(false);

  const [unitUnlocked, setUnitUnlocked] = useState(false);
  const [catUnlocked, setCatUnlocked] = useState(false);
  const [brandUnlocked, setBrandUnlocked] = useState(false);

  useEffect(() => {
    const fetchFeatureUnlocks = async () => {
      const unit = await FeatureLockWrapper.isFeatureUnlocked("unit_assignment");
      const cat = await FeatureLockWrapper.isFeatureUnlocked("category_assignment");
      const brand = await FeatureLockWrapper.isFeatureUnlocked("brand_assignment");

      setUnitUnlocked(unit);
      setCatUnlocked(cat);
      setBrandUnlocked(brand);
    };

    fetchFeatureUnlocks();
  }, []);



  const handleCategoryModal = (e) => {
    e?.stopPropagation();
    setIsCategoryModalOpen(!isCategoryModalOpen);
  };

  const handleBrandModal = (e) => {
    e?.stopPropagation();
    setIsBrandModalOpen(!isBrandModalOpen);
  };

  const handleUnitModal = (e) => {
    e?.stopPropagation();
    setIsUnitModalOpen(!isUnitModalOpen);
  };

  const fetchUserData = async () => {
    try {
      setLoading(true);
      const layouts = await get_user_auth();
      setUserData(layouts?.data || layouts);
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const handleModal = (e) => {
    e?.stopPropagation();
    setIsModalOpen(!isModalOpen);
  };

  const handleDelete = async (e) => {
    e?.stopPropagation();

    const data = {
      api: api,
      id: id,
    };

    const deleteTable = await delete_table(data);
    if (deleteTable?.status) {
      actiondata(data?.id);
      toast?.success(deleteTable?.message);
      setIsModalOpen(!isModalOpen);
    } else {
      setIsModalOpen(!isModalOpen);
      if (deleteTable?.status_code == 403) {
        window.location.href = "/unauthorized";
      } else {
        toast?.error(deleteTable?.message);
      }
    }
  };

  const canConvert = !loading && checkCreatePermission(headers, userData);

  const handleAssignmentSuccess = () => {
    if (type === 'category') {
      setIsCategoryModalOpen(false);
    } else if (type === 'brand') {
      setIsBrandModalOpen(false);
    } else if (type === 'unit') {
      setIsUnitModalOpen(false);
    }
    if (actiondata) {
      actiondata();
    }
  };

  const canEdit = !loading && checkUpdatePermission(headers, userData);
  const canDelete = !loading && checkDeletePermission(headers, userData);
  const [selectedFeature, setSelectedFeature] = useState(null);

  const handleLockedClick = (e, feature) => {
    e.preventDefault();
    setSelectedFeature(feature);
    setIsModalOpen(true);
  };

  return (
    <div className="text-xl text-gray-600 ">
      <Modal
        open={isModalOpen}
        onCancel={handleModal}
        centered={true}
        footer={[
          <div>
            <div className="">
              <Button
                className="cancel-btn transition duration-700 ease-in-out font-medium mr-2"
                onClick={handleModal}
              >
                Cancel
              </Button>
              <Button
                onClick={handleDelete}
                className="delete-btn transition duration-700 ease-in-out font-medium text-red-500 border-red-500"
              >
                Delete
              </Button>
            </div>
          </div>,
        ]}
      >
        <div>
          <div className="flex justify-center item-center py-2">
            <DeleteSvg className="text-red-600" width={40} height={40} />
          </div>

          <div className="py-4">
            <div className="text-xl text-medium text-center">
              Your about to delete
            </div>
            <div className="py-4">
              <div className="text-base text-gray-400 text-center">
                Are you sure want to delete ? You
              </div>
              <div className="text-base text-gray-400 text-center">
                will <span className="text-red-500">not be able to revert</span>
                &nbsp;this.
              </div>
            </div>
          </div>
        </div>
      </Modal>


      {isCategoryModalOpen && (
        <AssignCategoryModal
          open={isCategoryModalOpen}
          onClose={() => setIsCategoryModalOpen(false)}
          selectedProductIds={[]}
          onSuccess={handleAssignmentSuccess}
          productData={productData}
          cat_Id={cat_Id}
        />
      )}

      {isBrandModalOpen && (
        <AssignBrandModal
          open={isBrandModalOpen}
          onClose={() => setIsBrandModalOpen(false)}
          selectedProductIds={[]}
          onSuccess={handleAssignmentSuccess}
          productData={productData}
          brand_Id={brand_Id}
        />
      )}

      {isUnitModalOpen && (
        <AssignUnitModal
          open={isUnitModalOpen}
          onClose={() => setIsUnitModalOpen(false)}
          selectedProductIds={[]}
          onSuccess={handleAssignmentSuccess}
          productData={productData}
          unitData={unitData}
          unit_Id={unit_Id}
        />
      )}

      {edit && canEdit && (
        <button
          className="mx-2 hover:text-[#2d53da]"
          onClick={(e) => {
            e.stopPropagation();
            navigate(edit);
          }}
        >
          <FormOutlined />
        </button>
      )}

      {type === 'category' && (
        <FeatureLockWrapper
          featureKey="category_assignment"
          onClick={handleLockedClick}
        >
          <button
            className={`mx-2 ${catUnlocked && canEdit ? "hover:text-green-600" : "text-gray-400 cursor-not-allowed opacity-50"
              }`}
            onClick={catUnlocked && canEdit ? handleCategoryModal : undefined}
            title={catUnlocked ? "Assign Category" : "Unlock Category Assignment to assign categories"}
            disabled={!canEdit}
          >
            <TagsOutlined />
          </button>
        </FeatureLockWrapper>
      )}

      {type === 'brand' && (
        <FeatureLockWrapper
          featureKey="brand_assignment"
          onClick={handleLockedClick}
        >
          <button
            className={`mx-2 ${brandUnlocked && canEdit ? "hover:text-green-600" : "text-gray-400 cursor-not-allowed opacity-50"
              }`}
            onClick={brandUnlocked && canEdit ? handleBrandModal : undefined}
            title={brandUnlocked ? "Assign Brand" : "Unlock Brand Assignment to assign brands"}
            disabled={!canEdit}
          >
            <ShopOutlined />
          </button>
        </FeatureLockWrapper>
      )}

      {type === 'unit' && (
        <FeatureLockWrapper
          featureKey="unit_assignment"
          onClick={handleLockedClick}
        >
          <button
            className={`mx-2 ${unitUnlocked && canEdit ? "hover:text-green-600" : "text-gray-400 cursor-not-allowed opacity-50"
              }`}
            onClick={unitUnlocked && canEdit ? handleUnitModal : undefined}
            title={unitUnlocked ? "Assign Unit with Conversion" : "Unlock Unit Assignment to assign units"}
            disabled={!canEdit}
          >
            <AppstoreOutlined />
          </button>
        </FeatureLockWrapper>
      )}


      {api && canDelete && (
        <button className="mx-2 hover:text-red-500">
          <DeleteOutlined onClick={handleModal} />
        </button>
      )}
      {convert && canConvert && (
        <button
          className="mx-2 hover:text-[#2d53da]"
          onClick={(e) => {
            e.stopPropagation();
            navigate(convert);
          }}
        >
          <FileDoneOutlined />
        </button>
      )}

      {edit && !canEdit && (
        <button
          className="mx-2 text-gray-400 cursor-not-allowed opacity-50"
          disabled
          title="No edit permission"
        >
          <FormOutlined />
        </button>
      )}

      {api && !canDelete && (
        <button
          className="mx-2 text-gray-400 cursor-not-allowed opacity-50"
          disabled
          title="No delete permission"
        >
          <DeleteOutlined />
        </button>
      )}

      {convert && !canConvert && (
        <button
          className="mx-2 text-gray-400 cursor-not-allowed opacity-50"
          disabled
          title="No convert permission"
        >
          <FileDoneOutlined />
        </button>
      )}

      {selectedFeature && (
        <FeatureUnlockRequestModal
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            setSelectedFeature(null);
          }}
          feature={selectedFeature}
          onSuccess={() => {
            console.log("Feature unlocked successfully!");
          }}
        />
      )}

    </div>
  );
};

export default ActionButton;
